export default "__VITE_ASSET__BaTzFey0__"